import React from "react"
import ReactMarkdown from "react-markdown"

import Link from "@components/swipe-link"
import Image from "@components/image"
import Video, { getVideoFormat } from "@components/video"

import "./index.scss"

const Markdown = ({
  source,
  renderers = {},
  className,
  markdownClass = "markdown",
}) => (
  <ReactMarkdown
    renderers={{
      link: props => <Link to={props.href} reverse {...props} />,
      image: props => {
        const { src, alt, title } = props

        if (!src) {
          return null
        }

        if (!getVideoFormat(src)) {
          if (src.split('.').pop() === 'gif') {
            return <Image file={{ url: src }} title={title || alt} fm="" lazy />
          }

          return <Image file={{ url: src }} title={title || alt} w="900" lazy />
        }

        return <Video url={src} title={alt || title || src} />
      },
      ...renderers,
    }}
    className={`${markdownClass} ${className ? className : ""}`}
    source={source}
    escapeHtml={false}
  />
)

export default Markdown
